import axios from '@/plugins/axios';

const RATING_DETAIL = '/rating-detail';
const RATING_DETAIL_SELLER = '/rating-detail-seller';
const RATING_SETTING = 'rating-setting';

export async function getRatingDetail(payload) {
  try {
    const { data } = await axios.get(`${RATING_DETAIL}`, { params: payload });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getRatingDetailSeller(payload) {
  try {
    const { data } = await axios.get(`${RATING_DETAIL_SELLER}`, { params: payload });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function ratingSetting(payload) {
  try {
    const data = await axios.post(`${RATING_SETTING}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}
